import '../../css/SongDisplay.css';
import React, { useEffect, useState } from 'react';
import { SongDisplay } from './SongViews/SongDisplay';
import { Song } from '../../interfaces/userInterfaces';
import { usePublicData } from '../../hooks/usePublicData';
import { UserProfile } from '../../interfaces/userInterfaces';
import { fetchChats } from '../../services/fetch-utils';

import { PostgrestSingleResponse } from '@supabase/supabase-js';

interface MySongsProps {
  profile: UserProfile;
}

export const MySongs: React.FC<MySongsProps> = ({ profile }) => {
  const [songs, setSongs] = useState<Song[]>([]);
  const { isSongArray } = usePublicData();

  useEffect(() => {
    if (isSongArray(profile.songs)) {
      setSongs(profile.songs);
    } else {
      console.log('NO MATCH IN MYSONGS');
    }
  }, [profile]);

  useEffect(() => {
    if (profile?.username) {
      fetchChats(profile?.username).then((res: PostgrestSingleResponse<any[]>) => {
        if (!res.error) {
          console.log(res.data);
        } else console.log('CHATS FAILED');
      });
    }
  }, [profile]);

  return (
    <div
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}
    >
      {songs.length! > 0 &&
        songs.map((song, i) => {
          return (
            <div key={i} className="home-song-display">
              <SongDisplay {...song} />
            </div>
          );
        })}
      {songs.length === 0 && <h3>No Songs Have Been Uploaded</h3>}
    </div>
  );
};
